import moment from 'moment';

const
dateFormat = 'YYYY-MM-DD',
timeStampFormat = 'YYYY-MM-DD HH:MM:SS',
unixMiliFormat = 'x';

export const
FIVE_YEARS = 157784630000,
THIRTY_DAYS = 2592000000;

export function getCurrentUnixTime() {
    return moment().format(unixMiliFormat);
}

export function getTransactionDate() {
    return moment().format('MMMM Do YYYY, h:mm z');
}

export function unixSecondsToLongFormDate(unixSeconds, format='MMMM Do YYYY, h:mm:ss a') {
    if (unixSeconds!=null) return moment(unixSeconds, unixMiliFormat).local().format(format);
    return undefined;
}

export function unixSecondsToTimestampString(unixSeconds, format='YYYY-MM-DD HH:mm:ss') {
    if (unixSeconds!=null) return moment(unixSeconds, unixMiliFormat).local().format(format);
    else return undefined;
}

export function unixSecondsToDateString(unixSeconds, format='YYYY-MM-DD') {
    if (unixSeconds!=null) return moment(unixSeconds, unixMiliFormat).format(format);
    else return undefined;
}

export function dateStringToUnixTime(date) {
    if (date!=null) return moment(date, dateFormat).format(unixMiliFormat);
    else return undefined;
}

export function defaultBirthDateMoment() {
    return moment().subtract(9, 'years');
}

export function defaultBirthMinMoment() {
    return moment().subtract(5, 'years');
}

export function defaultBirthMaxMoment() {
    return moment().subtract(100, 'years');
}
